import React from 'react';
import Search from './components/Search';
import CategorySelect from './components/CategorySelect';
import StudioSelect from './components/StudioSelect';
import UnassignedCheckbox from './components/UnassignedCheckbox';
import ResetBtn from './components/ResetBtn';
import SortBy from './components/SortBy/SortBy';
import AssignBtn from './components/AssignBtn';
import style from './VideosControlPanel.module.scss';

const VideosControlPanel: React.FC = () => {
	return (
		<div data-test="VideosControlPanel">
			<Search />
			<div className={style.firstControlUnit}>
				<StudioSelect />
				<CategorySelect />
				<ResetBtn />
			</div>
			<div className={style.secondControlUnit}>
				<UnassignedCheckbox />
				<SortBy />
				<AssignBtn />
			</div>
		</div>
	);
};

export default VideosControlPanel;
